import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { TEST_IDS } from "../constants/testIds";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/auth/me")
      .then(() => navigate("/admin"))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Autenticato.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login fallito.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0C10] relative overflow-hidden flex items-center">
      <div className="absolute inset-0 bg-tech-grid opacity-30" />
      <div className="absolute -top-40 -right-40 w-[560px] h-[560px] bg-[#E31E24]/10 blur-3xl rounded-full pointer-events-none" />

      <div className="relative w-full max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-10 items-center py-24">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="col-span-12 md:col-span-6"
        >
          <Link
            to="/"
            className="eyebrow inline-flex items-center gap-3 hover:text-[#E31E24] transition-colors"
          >
            <span aria-hidden>←</span>
            Torna al sito
          </Link>
          <h1 className="mt-8 font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-6xl lg:text-7xl">
            Area
            <br />
            <span className="font-editorial italic font-light text-white/85">riservata</span>
            <br />
            <span className="text-[#E31E24]">Foxtherm.</span>
          </h1>
          <p className="mt-6 text-white/60 max-w-md leading-relaxed">
            Accedi per pubblicare nuove foto dai cantieri in corso. Le stesse
            credenziali funzionano dall&apos;app mobile via API.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.76, 0, 0.24, 1] }}
          className="col-span-12 md:col-span-5 md:col-start-8"
        >
          <form
            data-testid={TEST_IDS.admin.loginForm}
            onSubmit={submit}
            className="border border-white/10 bg-[#12151C] p-8 md:p-10 space-y-6"
          >
            <div className="eyebrow mb-2">01 · Login</div>
            <div>
              <label className="font-mono text-[10px] tracking-[0.28em] uppercase text-white/40 block mb-2">
                Email
              </label>
              <input
                data-testid={TEST_IDS.admin.loginEmail}
                type="email"
                required
                autoComplete="email"
                className="input-underline"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@foxtherm.it"
              />
            </div>
            <div>
              <label className="font-mono text-[10px] tracking-[0.28em] uppercase text-white/40 block mb-2">
                Password
              </label>
              <input
                data-testid={TEST_IDS.admin.loginPassword}
                type="password"
                required
                autoComplete="current-password"
                className="input-underline"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              data-testid={TEST_IDS.admin.loginSubmit}
              disabled={loading}
              className="btn-heat w-full justify-center disabled:opacity-60"
            >
              {loading ? "Accesso in corso…" : "Accedi"}
              <span aria-hidden>→</span>
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
